import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2d30e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "menu menu-column menu-pill menu-title-gray-600 menu-icon-gray-400 menu-state-primary menu-arrow-gray-500 fw-bold fs-5 my-5 mt-lg-2 mb-lg-0",
  id: "kt_aside_menu",
  "data-kt-menu": "true"
}
const _hoisted_2 = {
  class: "hover-scroll-y me-n3 pe-3",
  id: "kt_aside_menu_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_aside_menu",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-offset": "20px"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_4 = { class: "menu-content pt-8 pb-2" }
const _hoisted_5 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_6 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mx-1 my-4" }, null, -1))
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "menu-icon d-flex justify-content-end"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px"},
  class: "bi bi-clipboard-data"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "menu-icon d-flex justify-content-end"
}
const _hoisted_13 = { class: "menu-link" }
const _hoisted_14 = { class: "menu-title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_17 = ["href", "onClick"]
const _hoisted_18 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuComponent = _resolveComponent("MenuComponent")!

  return (_openBlock(), _createBlock(_component_MenuComponent, { "menu-selector": "#kt_aside_menu" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (item.heading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate(item.heading)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                            _createElementVNode("a", {
                              class: _normalizeClass([[isActive && 'active', isExactActive && 'active'], "menu-link hover-change-color"]),
                              href: href,
                              style: _normalizeStyle(_ctx.hoverByClickDb),
                              onClick: [
                                navigate,
                                _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hoverListDb && _ctx.hoverListDb(...args)), ["stop"]))
                              ]
                            }, [
                              (menuItem.svgIcon || menuItem.fontIcon)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
                                : _createCommentVNode("", true)
                            ], 14, _hoisted_8)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (menuItem.sectionTitle)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"]),
                        "data-kt-menu-sub": "accordion",
                        "data-kt-menu-trigger": "click"
                      }, [
                        _createElementVNode("span", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.subItemChange && _ctx.subItemChange(...args))),
                          class: "menu-link"
                        }, [
                          (menuItem.svgIcon || menuItem.fontIcon)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                _createElementVNode("i", {
                                  style: {"font-size":"20px"},
                                  class: _normalizeClass(menuItem.icon)
                                }, null, 2)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass([{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                              (item2.sectionTitle)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"]),
                                    "data-kt-menu-sub": "accordion",
                                    "data-kt-menu-trigger": "click"
                                  }, [
                                    _createElementVNode("span", _hoisted_13, [
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                      _hoisted_15
                                    ]),
                                    _createElementVNode("div", {
                                      class: _normalizeClass([{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                          (item3.heading)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createVNode(_component_router_link, {
                                                  to: item3.route
                                                }, {
                                                  default: _withCtx(({
                                href,
                                navigate,
                                isActive,
                                isExactActive,
                              }) => [
                                                    _createElementVNode("a", {
                                                      class: _normalizeClass(["menu-link", [
                                  isActive && 'active',
                                  isExactActive && 'active',
                                ]]),
                                                      href: href,
                                                      onClick: navigate
                                                    }, [
                                                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                    ], 10, _hoisted_17)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ], 2)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}